/**
 * Firebase **web** App IDs for this project's Console app registrations.
 *
 * Production has two web apps (different hashes): FireCMS and the marketing
 * site (`www.entspannungshelden.de`). The `getAppCheckToken` mint allowlist
 * includes every value here.
 *
 * Native (iOS / Android) App IDs must never be added here — App Check minting
 * for those platforms is DeviceCheck / Play Integrity, not `getAppCheckToken`.
 */
export const FIREBASE_WEB_APP_IDS = {
  /** FireCMS production web app. */
  PRODUCTION: "1:295518221716:web:1812938274bfe932c28b81",
  /** Marketing site production web app (`NEXT_PUBLIC_FIREBASE_APP_ID` on www). */
  PRODUCTION_MARKETING: "1:295518221716:web:27a495407ed5129ec28b81",
  DEVELOPMENT: "1:915174630485:web:9cb35531ec1a7b37ac20dc",
} as const;
